import { Card, OverlayTrigger, Tooltip } from 'react-bootstrap';

function CardItem(props: any) {

    const { image_url } = props;

    return (
        <Card className="custom-card w-25">
            <Card.Body>
                <div className="h-100  attached-file-grid6">
                    <div className="pro-img-box attached-file-image">
                        <img
                            className=" pic-1 pos-relative br-5 w-100"
                            src={image_url}
                            alt="attached-file"
                        />

                        {/* <ul className="icons">
                            <li className="me-1">
                                <OverlayTrigger
                                    placement="top"
                                    overlay={
                                        <Tooltip > Download</Tooltip>
                                    }
                                >
                                    <i className="fe fe-download"
                                        onClick={
                                            function () { handleDownload(file_path, 'singleFile') }
                                        }
                                    ></i>
                                </OverlayTrigger>
                            </li>
                        </ul> */}
                    </div>
                </div>
            </Card.Body>
        </Card>
    )
}

export default CardItem;